/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-19T17:51:38.566
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	saveRentRepairWorkOrderRelation,
	getRentRepairWorkOrderRelationCreateInit,
	getRentRepairWorkOrderRelationEditInit,
	getRentRepairWorkOrderRelationView,
	deleteRentRepairWorkOrderRelation
} from '@api/rentmanage/RentRepairWorkOrderRelation';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},
	actions: {
		getRentRepairWorkOrderRelationCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentRepairWorkOrderRelationCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentRepairWorkOrderRelationEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentRepairWorkOrderRelationEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentRepairWorkOrderRelation({}, RentRepairWorkOrderRelation) {
			return new Promise((resolve, reject) => {
				saveRentRepairWorkOrderRelation(RentRepairWorkOrderRelation)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		getRentRepairWorkOrderRelationView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentRepairWorkOrderRelationView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
		deleteRentRepairWorkOrderRelation({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentRepairWorkOrderRelation({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
